import { required, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { cityValidation } from '@jfs/ui-new/src/utils/validations'
import * as Yup from 'yup'
import { EmType } from '../..'
import { DatePickerReact } from '../../../../components/DatePicker'
import { Dropdown } from '../../../../components/Dropdown'
import { FeePackageDetails } from '../../../../components/FeePackageDetails'
import { MccCode } from '../../../../components/MccCode'
import { TextInputLabelToolTip } from '../../../../components/TextInputLabelToolTip'
import { TitleWithDashedLine } from '../../../../components/TitleWithDashedLine'
import { styles } from '../../styles'
import { ProgramDetails } from '../ProgramDetails'
import { gstValidation, panValidation } from './../../../../utils/index'

export const webAddressLength = Yup.string().max(40, 'Exceeds max length').required('Enter web address ')

export const pincode = Yup.string()
  .trim()
  .required('Required')
  .min(6, 'Please enter 6 digit pincode')
  .matches(/^[0-9]*$/, 'Incorrect pincode')

export const brandLegalNameValidation = Yup.string()
  .trim()
  .required('Required')
  .min(1, 'Minimum length is 1')
  .max(255, 'Max length is 40')
  .matches(/^[A-Za-z0-9? //&.]+$/, 'Incorrect Legal Entity Name')

export const brandNameValidation = Yup.string()
  .trim()
  .required('Required')
  .min(1, 'Minimum length is 1')
  .max(50, 'Max length is 50')
  .matches(/^[A-Za-z0-9? //&.]+$/, 'Incorrect Business Name')

export const brandName50Validation = Yup.string()
  .trim()
  .required('Required')
  .min(1, 'Minimum length is 1')
  .max(50, 'Max length is 50')
  .matches(/^[A-Za-z0-9? //&.]+$/, 'Incorrect Business Name')

export const latitudeValidation = Yup.string()
  .matches(/^(-?\d{1,2}(\.\d+)?|-\d{3}(\\.\\d+)?|NA?|(-?)[1-8]\d{0,1}(\.\d+)?)?$/, {
    excludeEmptyString: true,
    message: 'Invalid latitude',
  })
  .nullable()
  .notRequired()

export const longitudeValidation = Yup.string()
  .matches(/^-?((180(.0{1,6})?)|NA?|(((1[0-7]|[1-9])?\d)(\.\d{1,6})?))$/, {
    excludeEmptyString: true,
    message: 'Invalid longitude',
  })
  .nullable()
  .notRequired()

const pharmacyCouncilNumberValidation = Yup.string().matches(/^$|[a-zA-Z0-9]+$/, 'Invalid input')

const statusArray = [
  { id: 1, value: 'Approved' },
  { id: 2, value: 'Rejected' },
  { id: 3, value: 'Pending' },
]

const getSearchOnlyForm = (isLinkToMAS: boolean, getLovsFromKey: any, isEdit: boolean) => {
  return isLinkToMAS
    ? [
        {
          fieldName: 'premiseType',
          ComponentName: !isEdit ? TextInputNew : Dropdown,
          label: 'Premise Type',
          placeholder: '',
          title: isEdit ? 'Select' : undefined,
          validationSchema: isEdit ? required : undefined,
          editable: isEdit,
          data: getLovsFromKey('PremiseType'),
          ...(isEdit && { dataFieldToRead: 'description' }),
          ...styles.textinputStyle(isEdit),
          type: !isEdit ? 'body12' : 'default',
          testID: 'premiseType',
        },
        {
          fieldName: 'storeType',
          ComponentName: !isEdit ? TextInputNew : Dropdown,
          label: 'Store Type',
          placeholder: '',
          title: isEdit ? 'Select' : undefined,
          validationSchema: isEdit ? required : undefined,
          editable: isEdit,
          data: getLovsFromKey('StoreType'),
          ...(isEdit && { dataFieldToRead: 'description' }),
          ...styles.textinputStyle(isEdit),
          type: !isEdit ? 'body12' : 'default',
          testID: 'storeType',
        },
        {
          fieldName: 'businessType',
          ComponentName: !isEdit ? TextInputNew : Dropdown,
          label: 'Business Type',
          placeholder: '',
          title: isEdit ? 'Select' : undefined,
          validationSchema: isEdit ? required : undefined,
          editable: isEdit,
          data: getLovsFromKey('OwnerType'),
          ...(isEdit && { dataFieldToRead: 'description' }),
          ...styles.textinputStyle(isEdit),
          type: !isEdit ? 'body12' : 'default',
          testID: 'businessType',
        },
        {
          fieldName: 'mobileNumber',
          ComponentName: TextInputNew,
          label: 'Mobile Number',
          placeholder: '',
          editable: isEdit,
          validationSchema: isEdit ? required : undefined,
          ...styles.textinputStyle(isEdit),
          testID: 'mobileNumber',
        },
      ]
    : [
        {
          fieldName: 'spacer133',
          ComponentName: Spacer,
        },
        {
          fieldName: 'spacer133',
          ComponentName: Spacer,
        },
        {
          fieldName: 'spacer133',
          ComponentName: Spacer,
        },
        {
          fieldName: 'spacer133',
          ComponentName: Spacer,
        },
      ]
}

const getSearchOnlyCountry = (isLinkToMAS: boolean, isEdit: boolean, getLovsFromKey: any) => {
  return isLinkToMAS
    ? [
        {
          fieldName: 'stateUt',
          ComponentName: isEdit ? Dropdown : TextInputNew,
          label: 'State/UT',
          placeholder: '',
          title: isEdit ? 'Select' : undefined,
          validationSchema: isEdit ? required : undefined,
          editable: isEdit,
          data: isEdit ? getLovsFromKey('State') : undefined,
          ...styles.textinputStyle(isEdit),
          ...(isEdit && { dataFieldToRead: 'description' }),
          type: isEdit ? 'default' : 'body12',
          additionalWidth: 100,
          fullWidthContent: true,
          testID: 'stateUt',
        },
        {
          fieldName: 'country',
          ComponentName: TextInputNew,
          label: 'Country',
          placeholder: '',
          editable: isEdit,
          validationSchema: isEdit ? required : undefined,
          ...styles.textinputStyle(isEdit),
          testID: 'country',
        },
        {
          fieldName: 'businessLatitude',
          ComponentName: TextInputNew,
          label: 'Business Latitude (Optional)',
          placeholder: '',
          validationSchema: isEdit ? latitudeValidation : undefined,
          editable: isEdit,
          ...styles.textinputStyle(isEdit),
          testID: 'businessLatitude',
          paddingHorizontal: isEdit ? 8 : undefined,
        },
        {
          fieldName: 'businessLongitude',
          ComponentName: TextInputNew,
          label: 'Business Longitude (Optional)',
          placeholder: '',
          validationSchema: isEdit ? longitudeValidation : undefined,
          editable: isEdit,
          ...styles.textinputStyle(isEdit),
          testID: 'businessLongitude',
          paddingHorizontal: isEdit ? 8 : undefined,
        },
      ]
    : [
        {
          fieldName: 'stateUt',
          ComponentName: isEdit ? Dropdown : TextInputNew,
          label: 'State/UT',
          placeholder: '',
          title: isEdit ? 'Select' : undefined,
          validationSchema: isEdit ? required : undefined,
          editable: isEdit,
          data: isEdit ? getLovsFromKey('State') : undefined,
          ...styles.textinputStyle(isEdit),
          ...(isEdit && { dataFieldToRead: 'description' }),
          type: isEdit ? 'default' : 'body12',
          additionalWidth: 100,
          fullWidthContent: true,
          testID: 'stateUt',
        },
        {
          fieldName: 'businessLatitude',
          ComponentName: TextInputNew,
          label: 'Business Latitude (Optional)',
          placeholder: '',
          validationSchema: isEdit ? latitudeValidation : undefined,
          editable: isEdit,
          ...styles.textinputStyle(isEdit),
          testID: 'businessLatitude',
          paddingHorizontal: isEdit ? 8 : undefined,
        },
        {
          fieldName: 'businessLongitude',
          ComponentName: TextInputNew,
          label: 'Business Longitude (Optional)',
          placeholder: '',
          validationSchema: isEdit ? longitudeValidation : undefined,
          editable: isEdit,
          ...styles.textinputStyle(isEdit),
          testID: 'businessLongitude',
          paddingHorizontal: isEdit ? 8 : undefined,
        },
        {
          fieldName: 'spacer113',
          ComponentName: Spacer,
        },
      ]
}

const getFeePackageMdrForm = (
  isEdit: boolean,
  getLovsFromKey: any,
  showMdrFeePackage: boolean,
  isParentSelectedIsEntity: boolean,
) => {
  return showMdrFeePackage
    ? [
        {
          horizontalComps: [
            {
              fieldName: 'feePackage',
              ComponentName: TitleWithDashedLine,
              title: 'Fee Package',
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'feePackageDetails',
              ComponentName: FeePackageDetails,
              styles: styles,
              getLovsFromKey: getLovsFromKey,
              isEdit: isEdit,
              isParentSelectedIsEntity: isParentSelectedIsEntity,
            },
          ],
        },
      ]
    : []
}

export const subGroupOnlyDetails = (isEdit: boolean) => [
  {
    actionTitle: 'Proceed',
    key: 'businessDetails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'legalEntityName',
            ComponentName: TextInputLabelToolTip,
            label: 'Legal Entity Name',
            placeholder: '',
            validationSchema: brandLegalNameValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'legalEntityName',
            paddingHorizontal: isEdit ? 8 : 0,
            editable: isEdit,
          },
          {
            fieldName: 'businessBrandName',
            ComponentName: TextInputLabelToolTip,
            label: 'Name of Business',
            placeholder: '',
            validationSchema: brandNameValidation,
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: isEdit ? 8 : 0,
            color: 'BLACK_21',
            testID: 'businessBrandName',
            editable: isEdit,
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const buzzCreateGroupDetails = (
  isEdit: boolean,
  type: string,
  getLovsFromKey: any,
  primaryAddr1ToolTipInfo: any,
  primaryAddr2ToolTipInfo: any,
  pincodeToolTipInfo: any,
  bizzBrandNameToolTipInfo: any,
  cityToolTipInfo: any,
  stateToolTipInfo: any,
) => [
  {
    actionTitle: 'Proceed',
    key: 'businessDetails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'legalEntityName',
            ComponentName: TextInputLabelToolTip,
            label: 'Legal Entity Name',
            placeholder: '',
            validationSchema: brandLegalNameValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'legalEntityName',
            paddingHorizontal: isEdit ? 8 : 0,
            editable: isEdit,
            ...(type === EmType.applicationQueue && { labelToolTipInfo: primaryAddr1ToolTipInfo }),
          },
          {
            fieldName: 'businessBrandName',
            ComponentName: TextInputLabelToolTip,
            label: 'Name of Business',
            placeholder: '',
            validationSchema: brandName50Validation,
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: isEdit ? 8 : 0,
            color: 'BLACK_21',
            testID: 'businessBrandName',
            editable: isEdit,
            ...(type === EmType.applicationQueue && { labelToolTipInfo: bizzBrandNameToolTipInfo }),
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'businessAddressText',
            ComponentName: TitleWithDashedLine,
            title: 'Business Address',
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'primaryAddress1',
            ComponentName: TextInputLabelToolTip,
            label: 'Primary address1',
            placeholder: '',
            validationSchema: required,
            ...styles.textinputStyle(isEdit),
            maxLength: 40,
            color: 'BLACK_21',
            testID: 'primaryAddress1',
            paddingHorizontal: isEdit ? 8 : 0,
            ...(type === EmType.applicationQueue && { labelToolTipInfo: primaryAddr1ToolTipInfo }),
            multiline: true,
            editable: isEdit,
            numberOfLines: !isEdit ? 4 : 1,
          },
          {
            fieldName: 'primaryAddress2',
            ComponentName: TextInputLabelToolTip,
            label: 'Primary address2',
            placeholder: '',
            validationSchema: required,
            maxLength: 40,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'primaryAddress2',
            paddingHorizontal: isEdit ? 8 : 0,
            ...(type === EmType.applicationQueue && { labelToolTipInfo: primaryAddr2ToolTipInfo }),
            multiline: true,
            editable: isEdit,
            numberOfLines: !isEdit ? 4 : 1,
          },
          {
            fieldName: 'pincode',
            ComponentName: TextInputLabelToolTip,
            label: 'Pincode',
            placeholder: '',
            validationSchema: pincode,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            maxLength: 6,
            testID: 'pincode',
            paddingHorizontal: isEdit ? 8 : 0,
            editable: isEdit,
            ...(type === EmType.applicationQueue && { labelToolTipInfo: pincodeToolTipInfo }),
          },
          {
            fieldName: 'city',
            ComponentName: TextInputLabelToolTip,
            label: 'City',
            validationSchema: cityValidation,
            placeholder: '',
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'city',
            paddingHorizontal: isEdit ? 8 : 0,
            editable: isEdit,
            ...(type === EmType.applicationQueue && { labelToolTipInfo: cityToolTipInfo }),
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'stateUt',
            ComponentName: isEdit ? Dropdown : TextInputLabelToolTip,
            label: 'State/UT',
            placeholder: '',
            // value: stateUt,
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: isEdit ? getLovsFromKey('State') : undefined,
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: isEdit ? 8 : 0,
            type: isEdit ? 'default' : 'body12',
            testID: 'stateUt',
            ...(type === EmType.applicationQueue && { labelToolTipInfo: stateToolTipInfo }),
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const buzzDetailsSubGrp = (isEdit: boolean) => [
  {
    actionTitle: 'Proceed',
    key: 'businessDetailsSubGrp',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'legalEntityName',
            ComponentName: TextInputNew,
            label: 'Legal Entity Name',
            placeholder: '',
            validationSchema: brandLegalNameValidation,
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: isEdit ? 8 : 0,
            color: 'BLACK_21',
            testID: 'legalEntityName',
          },
          {
            fieldName: 'businessBrandName',
            ComponentName: TextInputNew,
            label: 'Name of Business',
            placeholder: '',
            validationSchema: brandNameValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'businessBrandName',
            paddingHorizontal: isEdit ? 8 : 0,
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const buzzDetailsSingleEntity = (
  isPharmacyCase: boolean,
  isEdit: boolean,
  isLinkToMAS: boolean,
  getLovsFromKey: any,
  selectedEntity: any,
  mccCode: string,
  merchantOtpDate: string,
  deviceOtpDate: string,
  jioGstAcceptanceTs: string,
  inheritFeePackageSelected: string,
  mdrPackageDetails: any,
  type: string,
  prefilledBizLine: string,
  prefilledBizCategory: string,
) => [
  {
    actionTitle: 'Proceed',
    key: 'buzzDetailsSingleEntity',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'legalEntityName',
            ComponentName: TextInputNew,
            label: 'Legal Entity Name',
            placeholder: '',
            validationSchema: brandLegalNameValidation,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'legalEntityName',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'businessBrandName',
            ComponentName: TextInputNew,
            label: 'Name of Business',
            placeholder: '',
            editable: isEdit,
            validationSchema: brandNameValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'businessBrandName',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'ownershipType',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Ownership Type',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            data: getLovsFromKey('OwnershipType'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'ownershipType',
          },
          {
            fieldName: 'businessChannel',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Business Channel',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('BusinessChannel'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'businessChannel',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'setupLevel',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Setup Level',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('SetupLevel'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'setupLevel',
          },
          {
            fieldName: 'premiseType',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Premise Type',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('PremiseType'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'premiseType',
          },
          {
            fieldName: 'businessPAN',
            ComponentName: TextInputNew,
            label: 'Business PAN',
            placeholder: '',
            validationSchema: isEdit ? panValidation : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            maxLength: 10,
            testID: 'businessPAN',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'webAddress',
            ComponentName: TextInputNew,
            label: 'Web address',
            placeholder: '',
            validationSchema: isEdit ? webAddressLength : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'webAddress',
            paddingHorizontal: isEdit ? 8 : undefined,
            maxLength: 40,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'storeType',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Store Type',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('StoreType'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'storeType',
          },
          {
            fieldName: 'yearsOfBusiness',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Years in business',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('YearsInBusiness'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'yearsOfBusiness',
          },
          {
            fieldName: 'merchantOtpDate',
            ComponentName: !isEdit ? TextInputNew : DatePickerReact,
            label: 'Merchant OTP date',
            placeholder: '',
            dateValue: !isEdit ? '' : merchantOtpDate,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'merchantOtpDate',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'spacer98798',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'spacer987',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer988',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer10',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer133',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'businessCategoryTitle',
            ComponentName: TitleWithDashedLine,
            title: 'Business Category',
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'mccCodeComponent',
            ComponentName: MccCode,
            isEdit: isEdit,
            styles: styles,
            prefilledMccCode: mccCode,
            prefilledBizLine: prefilledBizLine,
            prefilledBizCategory: prefilledBizCategory,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: isPharmacyCase ? 'pharmacyCouncilNumber' : 'spacer3423',
            ComponentName: isPharmacyCase ? TextInputNew : Spacer,
            label: isPharmacyCase ? 'Pharmacy council No' : undefined,
            placeholder: isPharmacyCase ? '' : undefined,
            validationSchema: isPharmacyCase ? pharmacyCouncilNumberValidation : undefined,
            editable: isPharmacyCase ? isEdit : undefined,
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: isPharmacyCase ? 8 : 0,
            testID: isPharmacyCase ? 'pharmacyCouncilNumber' : 'spacer3423',
          },
          {
            fieldName: 'spacer134',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer135',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer136',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'businessAddressText',
            ComponentName: TitleWithDashedLine,
            title: 'Business Address',
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'primaryAddress1',
            ComponentName: TextInputNew,
            label: 'Primary Address1',
            placeholder: '',
            multiline: true,
            maxLength: 50,
            numberOfLines: !isEdit ? 4 : 1,
            // value: primaryAddress1,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'primaryAddress1',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'primaryAddress2',
            ComponentName: TextInputNew,
            label: 'Primary Address2',
            placeholder: '',
            multiline: true,
            maxLength: 50,
            numberOfLines: !isEdit ? 4 : 1,
            // value: primaryAddress2,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'primaryAddress2',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'pincode',
            ComponentName: TextInputNew,
            label: 'Pincode',
            placeholder: '',
            validationSchema: isEdit ? pincode : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            maxLength: 6,
            testID: 'pincode',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'city',
            ComponentName: TextInputNew,
            label: 'City',
            placeholder: '',
            validationSchema: isEdit ? cityValidation : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'city',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'stateUt',
            ComponentName: isEdit ? Dropdown : TextInputNew,
            label: 'State/UT',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: isEdit ? getLovsFromKey('State') : undefined,
            ...styles.textinputStyle(isEdit),
            ...(isEdit && { dataFieldToRead: 'description' }),
            type: isEdit ? 'default' : 'body12',
            testID: 'stateUt',
          },
          {
            fieldName: 'businessLatitude',
            ComponentName: TextInputNew,
            label: 'Business Latitude (Optional)',
            placeholder: '',
            validationSchema: isEdit ? latitudeValidation : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'businessLatitude',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'businessLongitude',
            ComponentName: TextInputNew,
            label: 'Business Longitude (Optional)',
            placeholder: '',
            validationSchema: isEdit ? longitudeValidation : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'businessLongitude',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'gstTitle',
            ComponentName: TitleWithDashedLine,
            title: 'GST Details',
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'gstCategory',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'GST Category',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('MerchantCategory'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'gstCategory',
          },
          {
            fieldName: 'gstDealerCategory',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'GST Dealer Category',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('GSTDealerCategory'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'gstDealerCategory',
          },
          {
            fieldName: 'typeOfBusiness',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Type Of Business',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('BusinessType'),
            ...(isEdit && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'typeOfBusiness',
          },
          {
            fieldName: 'gstNumber',
            ComponentName: TextInputNew,
            label: 'GST Number',
            placeholder: '',
            maxLength: 15,
            validationSchema: isEdit ? gstValidation : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'gstNumber',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'jioGstAcceptanceTs',
            ComponentName: !isEdit ? TextInputNew : DatePickerReact,
            timeInputLabel: 'Time:',
            dateFormat: 'dd-MM-yyyy h:mm aa',
            showTimeInput: true,
            label: 'Jio GST Acceptance TS',
            placeholder: '',
            dateValue:
              jioGstAcceptanceTs !== 'NA' && jioGstAcceptanceTs !== 'N' && jioGstAcceptanceTs !== 'Y'
                ? jioGstAcceptanceTs
                : '',
            validationSchema: !isEdit ? required : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'jioGstAcceptanceTs',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'spacer114',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer114',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer115',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'programDetails',
            ComponentName: ProgramDetails,
            isEdit: isEdit,
            selectedEntity: selectedEntity,
            type: type,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
export const filteredGstCategories = (gstCategories: any) => {
  return gstCategories?.map((item) => item.description).filter((item) => item !== 'UNREGISTERED' && item !== 'NA') ?? []
}
export const newBuzzDetailsEMSOnlyEntity = (
  isEdit: boolean,
  getLovsFromKey: any,
  mccCode: string,
  mdrPackageDetails: any,
  showMdrFeePackage: boolean,
  parentFeePackageDetails: any,
  isInheritFromParentFeePackage: boolean,
  prefilledBizLine: string,
  prefilledBizCategory: string,
  isParentSelectedIsEntity: boolean,
  businessChannelSelected: any,
  selectedEntity: any,
  type: string,
  isLinkToMAS: boolean,
  showAllFields: boolean,
) => {
  const gstCategories = getLovsFromKey('MerchantCategory')

  const allFields = [
    {
      actionTitle: 'Proceed',
      key: 'newBuzzDetailsEMSOnlyEntity',
      formItems: [
        {
          horizontalComps: [
            {
              fieldName: 'legalEntityName',
              ComponentName: TextInputNew,
              label: 'Legal Entity Name',
              placeholder: '',
              validationSchema: brandLegalNameValidation,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              color: 'BLACK_21',
              testID: 'legalEntityName',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'businessBrandName',
              ComponentName: TextInputNew,
              label: 'Name of Business',
              placeholder: '',
              editable: isEdit,
              validationSchema: brandNameValidation,
              ...styles.textinputStyle(isEdit),
              color: 'BLACK_21',
              testID: 'businessBrandName',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'ownershipType',
              ComponentName: !isEdit ? TextInputNew : Dropdown,
              label: 'Ownership Type',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              data: getLovsFromKey('OwnershipType'),
              ...(isEdit && { dataFieldToRead: 'description' }),
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'ownershipType',
            },
            {
              fieldName: 'businessChannel',
              ComponentName: !isEdit ? TextInputNew : Dropdown,
              label: 'Business Channel',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              additionalWidth: 50,
              fullWidthContent: true,
              data: getLovsFromKey('BusinessChannel'),
              ...(isEdit && { dataFieldToRead: 'description' }),
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'businessChannel',
            },
          ],
          horizontalSpacing: 8,
        },
        {
          horizontalComps: [
            {
              fieldName: 'setupLevel',
              ComponentName: !isEdit ? TextInputNew : Dropdown,
              label: 'Setup Level',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              additionalWidth: 150,
              fullWidthContent: true,
              data: getLovsFromKey('SetupLevel'),
              ...(isEdit && { dataFieldToRead: 'description' }),
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'setupLevel',
            },
            {
              fieldName: 'businessPAN',
              ComponentName: TextInputNew,
              label: 'Business PAN',
              placeholder: '',
              validationSchema: isEdit ? panValidation : undefined,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              maxLength: 10,
              testID: 'businessPAN',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'webAddress',
              ComponentName: TextInputNew,
              label: 'Web address',
              placeholder: '',
              validationSchema:
                isEdit && businessChannelSelected && businessChannelSelected?.toLowerCase()?.includes('online')
                  ? webAddressLength
                  : undefined,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'webAddress',
              paddingHorizontal: isEdit ? 8 : undefined,
              maxLength: 40,
            },
            {
              fieldName: 'yearsOfBusiness',
              ComponentName: !isEdit ? TextInputNew : Dropdown,
              label: 'Years in business',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              //validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              data: getLovsFromKey('YearsInBusiness'),
              ...(isEdit && { dataFieldToRead: 'description' }),
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'yearsOfBusiness',
            },
          ],
          horizontalSpacing: 8,
        },
        {
          horizontalComps: getSearchOnlyForm(isLinkToMAS, getLovsFromKey, isEdit),
          horizontalSpacing: 8,
        },
        {
          horizontalComps: [
            {
              fieldName: 'businessCategoryTitle',
              ComponentName: TitleWithDashedLine,
              title: 'Business Category',
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'mccCodeComponent',
              ComponentName: MccCode,
              isEdit: isEdit,
              styles: styles,
              prefilledMccCode: mccCode,
              prefilledBizLine: prefilledBizLine,
              prefilledBizCategory: prefilledBizCategory,
            },
          ],
          horizontalSpacing: 8,
        },
        {
          horizontalComps: [
            {
              fieldName: 'businessAddressText',
              ComponentName: TitleWithDashedLine,
              title: 'Business Address',
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'primaryAddress1',
              ComponentName: TextInputNew,
              label: 'Primary Address1',
              placeholder: '',
              multiline: true,
              maxLength: 40,
              numberOfLines: !isEdit ? 4 : 1,
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'primaryAddress1',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'primaryAddress2',
              ComponentName: TextInputNew,
              label: 'Primary Address2',
              placeholder: '',
              multiline: true,
              numberOfLines: !isEdit ? 4 : 1,
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'primaryAddress2',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'pincode',
              ComponentName: TextInputNew,
              label: 'Pincode',
              placeholder: '',
              validationSchema: isEdit ? pincode : undefined,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              maxLength: 6,
              testID: 'pincode',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'city',
              ComponentName: TextInputNew,
              label: 'City',
              placeholder: '',
              validationSchema: isEdit ? cityValidation : undefined,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'city',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
          horizontalSpacing: 8,
        },
        {
          horizontalComps: getSearchOnlyCountry(isLinkToMAS, isEdit, getLovsFromKey),
          horizontalSpacing: 8,
        },
        {
          horizontalComps: [
            {
              fieldName: 'gstTitle',
              ComponentName: TitleWithDashedLine,
              title: 'GST Details',
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'gstCategory',
              ComponentName: !isEdit ? TextInputNew : Dropdown,
              label: 'GST Category',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              data: gstCategories,
              ...(isEdit && { dataFieldToRead: 'description' }),
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'gstCategory',
              additionalWidth: 100,
              fullWidthContent: true,
            },
            {
              fieldName: 'gstDealerCategory',
              ComponentName: !isEdit ? TextInputNew : Dropdown,
              label: 'GST Dealer Category',
              dependency: ['gstCategory', filteredGstCategories(gstCategories)],
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              data: getLovsFromKey('GSTDealerCategory'),
              ...(isEdit && { dataFieldToRead: 'description' }),
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'gstDealerCategory',
            },
            {
              fieldName: 'typeOfBusiness',
              ComponentName: !isEdit ? TextInputNew : Dropdown,
              label: 'Type Of Business',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              dependency: ['gstCategory', filteredGstCategories(gstCategories)],
              data: getLovsFromKey('BusinessType'),
              ...(isEdit && { dataFieldToRead: 'description' }),
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'typeOfBusiness',
            },
            {
              fieldName: 'gstNumber',
              ComponentName: TextInputNew,
              label: 'GST Number',
              placeholder: '',
              maxLength: 15,
              validationSchema: isEdit ? gstValidation : undefined,
              editable: isEdit,
              dependency: ['gstCategory', filteredGstCategories(gstCategories)],
              ...styles.textinputStyle(isEdit),
              testID: 'gstNumber',
              paddingHorizontal: isEdit ? 8 : undefined,
              multiline: true,
              numberOfLines: !isEdit ? 4 : 1,
            },
          ],
          horizontalSpacing: 8,
        },
        {
          horizontalComps: [
            {
              fieldName: 'spacer114',
              ComponentName: Spacer,
            },
            {
              fieldName: 'spacer115',
              ComponentName: Spacer,
            },
          ],
          horizontalSpacing: 8,
        },
        {
          horizontalComps: [
            {
              fieldName: 'programDetails',
              ComponentName: ProgramDetails,
              isEdit: isEdit,
              selectedEntity: selectedEntity,
              type: type,
            },
          ],
        },
        ...getFeePackageMdrForm(isEdit, getLovsFromKey, showMdrFeePackage, isParentSelectedIsEntity),
      ],
      horizontalFlex: 1,
      onSubmit: async () => {
        return ''
      },
    },
  ]
  const mandatoryFields = [
    {
      actionTitle: 'Proceed',
      key: 'newBuzzDetailsEMSOnlyEntity',
      formItems: [
        {
          horizontalComps: [
            {
              fieldName: 'legalEntityName',
              ComponentName: TextInputNew,
              label: 'Legal Entity Name',
              placeholder: '',
              validationSchema: brandLegalNameValidation,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              color: 'BLACK_21',
              testID: 'legalEntityName',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'businessBrandName',
              ComponentName: TextInputNew,
              label: 'Name of Business',
              placeholder: '',
              editable: isEdit,
              validationSchema: brandNameValidation,
              ...styles.textinputStyle(isEdit),
              color: 'BLACK_21',
              testID: 'businessBrandName',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'spacer1141',
              ComponentName: Spacer,
            },
            {
              fieldName: 'spacer1151',
              ComponentName: Spacer,
            },
          ],
          horizontalSpacing: 8,
        },
      ],
      horizontalFlex: 1,
    },
  ]
  return showAllFields ? allFields : mandatoryFields
}

export const buzzDetailsSearchByGroupId = (isEdit: boolean, getLovsFromKey: any) => [
  {
    actionTitle: 'Proceed',
    key: 'businessDetailsSearchByGroupId',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'legalEntityName',
            ComponentName: TextInputNew,
            label: 'Legal Entity Name',
            placeholder: '',
            validationSchema: brandLegalNameValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'legalEntityName',
            editable: isEdit,
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'businessBrandName',
            ComponentName: TextInputNew,
            label: 'Name of Business',
            placeholder: '',
            validationSchema: brandNameValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'businessBrandName',
            editable: isEdit,
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'businessAddressText',
            ComponentName: TitleWithDashedLine,
            title: 'Business Address',
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'primaryAddress1',
            ComponentName: TextInputNew,
            label: 'Primary address1',
            placeholder: '',
            validationSchema: required,
            maxLength: 40,
            ...styles.textinputStyle(isEdit),
            labelToolTipInfo: undefined, //{ originalData: 'orgdata1m', maker: 'makerDatae1m', updatedOn: '7 Mar 2023 12:38 pm' },
            color: 'BLACK_21',
            testID: 'primaryAddress1',
            multiline: true,
            numberOfLines: !isEdit ? 4 : 1,
            editable: isEdit,
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'primaryAddress2',
            ComponentName: TextInputNew,
            label: 'Primary address2',
            labelToolTipInfo: undefined, //{ originalData: 'orgdata1m', maker: 'makerDatae1m', updatedOn: '7 Mar 2023 12:38 pm' },
            placeholder: '',
            validationSchema: required,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'primaryAddress2',
            multiline: true,
            numberOfLines: !isEdit ? 4 : 1,
            editable: isEdit,
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'pincode',
            ComponentName: TextInputNew,
            label: 'Pincode',
            placeholder: '',
            validationSchema: pincode,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            maxLength: 6,
            testID: 'pincode',
            editable: isEdit,
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'city',
            ComponentName: TextInputNew,
            label: 'City',
            placeholder: '',
            validationSchema: cityValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'city',
            editable: isEdit,
            paddingHorizontal: isEdit ? 8 : undefined,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'stateUt',
            ComponentName: isEdit ? Dropdown : TextInputNew,
            label: 'State/UT',
            placeholder: '',
            // value: stateUt,
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: isEdit ? getLovsFromKey('State') : undefined,
            ...styles.textinputStyle(isEdit),
            ...(isEdit && { dataFieldToRead: 'description' }),
            paddingHorizontal: isEdit ? 0 : 8,
            type: isEdit ? 'default' : 'body12',
            testID: 'stateUt',
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      // ...getMakerCheckerForm(isEdit, getLovsFromKey),
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const buzzDetailsSearchBySubGroupId = (isEdit: boolean, getLovsFromKey: any) => [
  {
    actionTitle: 'Proceed',
    key: 'businessDetailsSearchBySubGroupId',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'legalEntityName',
            ComponentName: TextInputNew,
            label: 'Legal Entity Name',
            placeholder: '',
            validationSchema: brandLegalNameValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'legalEntityName',
            editable: isEdit,
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'businessBrandName',
            ComponentName: TextInputNew,
            label: 'Name of Business',
            placeholder: '',
            validationSchema: brandNameValidation,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'businessBrandName',
            editable: isEdit,
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      // ...getMakerCheckerForm(isEdit, getLovsFromKey),
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
